import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TrendingUp, ArrowRight, Clock } from "lucide-react";

/** Dashboard widget: top 3 personalized course recommendations. */
export default function RoadmapCard() {
  const [data, setData] = useState({ next_actions: [], score: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/learning/roadmap");
        setData(r.data);
      } catch { /* noop */ }
      setLoading(false);
    })();
  }, []);

  if (loading) return null;
  if (!data.next_actions.length) return null;

  return (
    <div data-testid="roadmap-card" className="border border-white/5 bg-[#0c0c0c] p-7 mb-px">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-5">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp size={16} className="text-amber-500" />
            <div className="text-overline">BeatCredsi Academy<span className="text-amber-500">™</span></div>
          </div>
          <p className="text-sm text-neutral-400 max-w-2xl">
            <span className="text-amber-500/80 font-mono-tech text-xs uppercase tracking-widest">Learn · Certify · Improve</span><br />
            Personalized course path based on your BeatCredsi Score and missing infrastructure. Complete &amp; certify → score climbs → tier advances.
          </p>
        </div>
        <Link to="/courses" data-testid="view-all-courses"
          className="text-xs font-mono-tech uppercase tracking-widest text-amber-500 hover:underline shrink-0">
          View all courses →
        </Link>
      </div>

      <div className="space-y-2">
        {data.next_actions.map((a) => (
          <Link key={a.course_id} to={`/courses/${a.slug}`}
            data-testid={`roadmap-action-${a.slug}`}
            className="flex items-center gap-4 p-4 bg-[#0A0A0A] border border-white/5 hover:border-amber-500/40 transition-colors group">
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-white mb-0.5">{a.title}</div>
              <div className="text-xs text-neutral-400 mb-1">{a.summary}</div>
              <div className="text-xs font-mono-tech uppercase tracking-widest text-amber-500/80">
                ↳ {a.reason}
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="font-display text-2xl text-amber-500 leading-none">+{a.score_boost}</div>
              <div className="text-xs font-mono-tech text-neutral-500 mt-1 flex items-center gap-1 justify-end">
                <Clock size={10} /> ~{a.estimated_minutes}m
              </div>
            </div>
            <ArrowRight size={14} className="text-neutral-500 group-hover:text-amber-500 group-hover:translate-x-1 transition-all shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
